<div class="time-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>

  <mat-dialog-content>
    <p class="time-dialog__description">
      {{ data.description || 'Enter the local time and confirm the UTC conversion before applying it.' }}
    </p>
    <div class="time-dialog__controls">
      <mat-form-field appearance="outline" class="time-dialog__field">
        <mat-label>Local Time</mat-label>
        <input
          matInput
          type="text"
          autocomplete="off"
          placeholder="HH:mm"
          [ngModel]="localTime24"
          (ngModelChange)="onTimeChange($any($event))"
          (blur)="onTimeBlur()"
        />
        <mat-hint class="time-dialog__hint">Validated manual input in 24-hour format</mat-hint>
      </mat-form-field>

      <button
        mat-stroked-button
        type="button"
        class="time-dialog__picker-button"
        (click)="openPicker()"
      >
        <mat-icon>schedule</mat-icon>
        Use Clock
      </button>
    </div>

    <ngx-material-timepicker
      #timepicker
      [format]="24"
      [enableKeyboardInput]="false"
      [appendToInput]="false"
      timepickerClass="local-time-dialog-timepicker"
      (timeSet)="onTimePicked($any($event))"
    ></ngx-material-timepicker>

    <div class="time-dialog__preview" *ngIf="utcPreview">
      UTC preview: {{ utcPreview }}
    </div>

    <div class="time-dialog__error" *ngIf="validationMessage">
      {{ validationMessage }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="btns">
    <button mat-stroked-button class="custom-button" (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="apply()" [disabled]="isApplyDisabled">Apply</button>
  </mat-dialog-actions>
</div>